import { isSameRootDomain } from './domain'

const SSO_URL = 'https://sso.hocnhe.com'
const SSO_LOGIN_URL = `${SSO_URL}/auth/login`

/**
 * Tạo URL redirect sang SSO login.
 *
 * - Cùng root domain (*.hocnhe.com): SSO set cookie .hocnhe.com, app đọc luôn.
 *   → redirect_url = trang hiện tại (hoặc origin)
 *
 * - Khác domain (localhost, domain khác): Cookie không share.
 *   → redirect_url = /auth/callback, SSO kèm ?code=xxx, app exchange lấy token.
 */
export function getSSOLoginUrl(returnTo?: string): string {
  const sameDomain = isSameRootDomain(window.location.href, SSO_URL)

  if (sameDomain) {
    const target = returnTo || window.location.href
    return `${SSO_LOGIN_URL}?redirect_url=${encodeURIComponent(target)}`
  } else {
    const callbackUrl = `${window.location.origin}/auth/callback`
    return `${SSO_LOGIN_URL}?redirect_url=${encodeURIComponent(callbackUrl)}`
  }
}

export function redirectToSSOLogin(returnTo?: string): void {
  window.location.href = getSSOLoginUrl(returnTo)
}

export { SSO_URL }
